module.exports = __webpack_public_path__ + "static/media/Artboard13.38a5c794.png";